import React, {useEffect, useState} from 'react';
import {Box, Checkbox, Stack} from '@mui/material';
import PropTypes from 'prop-types';
import RequiredCheckbox from './Shared/RequiredCheckbox';
import RichEditor from './Shared/RichEditor';
import RichEditorResultText from './Shared/RichEditorResultText';
import {stripHtmlTags} from './AdditionalNotes';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

const CheckboxQuestion = ({
                              index,
                              id,
                              value,
                              onChange,
                              description,
                              isEditMode,
                              enableValidation,
                              isFormArchived,
                              readonly,
                              placeholderValues,
                              accessLevel,
                              error,
                              audience,
                              recipientType,
                          }) => {
    const [currentDescription, setCurrentDescription] = useState(description ?? '');

    useEffect(() => {
        setCurrentDescription(description ?? '');
    }, [description]);

    const handleDescriptionChange = (nextValue) => {
        setCurrentDescription(nextValue);

        if (!onChange) return;

        onChange({
            index,
            description: stripHtmlTags(nextValue),
            formattedDescription: nextValue,
        });
    };

    return (
        <Box sx={{mt: 2}}>
            {isEditMode
                ? (
                    <>
                        <RichEditor
                            value={description}
                            onChange={onChange}
                            index={index}
                            isEditMode={isEditMode}
                            isFormLive={isFormArchived}
                            accessLevel={accessLevel}
                            currentDescription={currentDescription}
                            setCurrentDescription={handleDescriptionChange}
                            audience={audience}
                            recipientType={recipientType}
                        />
                        <Stack
                            flexDirection="row"
                            justifyContent="space-between"
                            gap={3}
                        >
                            <RequiredCheckbox
                                enableValidation={enableValidation}
                                index={index}
                                onChange={onChange}
                                isFormArchived={isFormArchived}
                            />
                    </Stack>
                </>
                )
                : (
                    <FormControl
                    key={`${description}-${value}`}
                    error={!!error}
                    variant="standard"
                    fullWidth
                    >
                        <Stack
                            flexDirection="row"
                            justifyContent="space-between"
                            alignItems="center"
                            gap={2}
                        >
                            <RichEditorResultText
                                id={id}
                                description={description}
                                placeholderValues={placeholderValues}
                                readonly={readonly}
                                enableValidation={enableValidation}
                                error={!!error}
                        />
                            <Checkbox
                                value={value}
                                checked={!!value}
                                disabled={readonly}
                                onChange={e =>
                                    onChange({
                                        id,
                                        value: e.target.checked,
                                    })
                                }
                            />
                    </Stack>
                    <FormHelperText>{error}</FormHelperText>
                </FormControl>
                )}
        </Box>
    );
};

CheckboxQuestion.propTypes = {
    id: PropTypes.string,
    value: PropTypes.bool,
    index: PropTypes.number,
    description: PropTypes.string,
    enableValidation: PropTypes.bool,
    onChange: PropTypes.func,
    isEditMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    readonly: PropTypes.bool,
    placeholderValues: PropTypes.object,
    accessLevel: PropTypes.number,
    error: PropTypes.string,
    audience: PropTypes.number,
    recipientType: PropTypes.string,
};

export default CheckboxQuestion;
